import React from 'react';
import classNames from 'classnames';
import { Check, X } from 'react-feather';

import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

export default function LearnerUnselectableResponse({
  response,
  activeResponse,
}) {
  const activeResponseCorrect =
    activeResponse && activeResponse.correct ? 'correct' : 'incorrect';
  const isActiveResponse = response.id === activeResponse.id;
  const bubbleStyleNames = classNames(
    'OnDemandPracticeConversation-chatBubble OnDemandPracticeConversation-chatBubbleRight',
    {
      [`active-${activeResponse.id}`]: isActiveResponse,
    },
  );
  const responseText = response.subject || response.text;
  return (
    <div key={response.id}>
      <div className={bubbleStyleNames}>
        <p
          className={classNames('mb-0', {
            'fs-i':
              responseText ===
                t(
                  'practice.on_demand_practice.editor.conversations.correct_response_filler',
                ) ||
              responseText ===
                t(
                  'practice.on_demand_practice.editor.conversations.incorrect_response_filler',
                ),
          })}
        >
          {responseText}
        </p>
      </div>
      {isActiveResponse && (
        <div className="OnDemandPracticeConversation-explanation">
          <span className={`${activeResponseCorrect} d-f ai-c`}>
            {activeResponse && activeResponse.correct ? (
              <Check size={20} className="mr-4 c-success" />
            ) : (
              <X size={20} className="mr-4 c-danger-red" />
            )}
            <Text variant={TEXT_VARIANTS.BODY_BOLD}>
              {t(
                `practice.on_demand_practice.conversation.${activeResponseCorrect}`,
              )}
            </Text>
          </span>
          <Text className="mb-0" component="p" variant={TEXT_VARIANTS.BODY}>
            {response.explanation}
          </Text>
        </div>
      )}
    </div>
  );
}
